import Paginacion from "./Paginacion";

export default function Villanos (){
    return(
        <div>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                        <h1 className="text-center titulo">
                            LOS CRIMINALES MÁS PELIGROSOS DE CIUDAD GÓTICA
                        </h1>
                    </div>
                </div>
            </div>

            <hr></hr>

            <div className="villanos">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <h1 className="titulo text-center">JOKER</h1>
                            <hr></hr>
                            <p><strong>Nombre real:</strong> Desconocido</p>
                            <hr className="w-25"></hr>
                            <p>"Si voy a tener un pasado, prefiero que sea de opción múltiple."</p>
                            <p>
                                El Joker no es un criminal común, sino una mente completamente
                                desatada que encuentra diversión en el sufrimiento y el caos.
                                Con una sonrisa permanente dibujada en su rostro, transforma
                                la violencia y la tragedia en un espectáculo macabro donde
                                la ciudad se convierte en su escenario.
                            </p>
                            <p>
                                A diferencia de otros villanos, el Joker no busca poder ni
                                dinero.
                                Su verdadero placer está en romper la mente de las personas,
                                llevarlas al límite y demostrar que cualquiera puede caer
                                en la locura. Para él, la vida es solo un mal chiste y
                                Ciudad Gótica es el lugar perfecto para contarlo.
                            </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                            <img src="/imagenes/joker.jpg" className="img-fluid" alt="joker"></img>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <h1 className="titulo text-center">
                                SCARECROW
                            </h1>
                            <hr></hr>
                            <p>
                                <strong>Nombre real: </strong>Jonathan Crane<br></br>
                                <strong>Especialidad: </strong>Toxina del miedo
                            </p>
                            <hr className="w-25"></hr>
                            <p>
                                Scarecrow, es uno de los villanos más inquietantes de
                                Ciudad Gótica.
                                Antiguamente fue un brillante profesor de psicología
                                especializado en el estudio del miedo, pero sus métodos
                                extremos y poco éticos lo llevaron a ser expulsado del
                                mundo académico.
                            </p>
                            <p>
                                Obsesionado con comprender y controlar el miedo humano, Crane
                                desarrolló una poderosa toxina capaz de provocar alucinaciones
                                y los peores temores de sus víctimas. Bajo la identidad de
                                Scarecrow, utiliza este gas del miedo para sembrar pánico en
                                Ciudad Gótica y demostrar que incluso las personas más valientes
                                pueden quebrarse ante sus propios temores.
                            </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                            <img src="/imagenes/scarecrow.jpg" className="img-fluid" alt="scarecrow"></img>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <h1 className="titulo text-center">BANE</h1>
                            <hr></hr>
                            <p>
                                <strong>Nombre real: </strong>Desconocido<br></br>
                                <strong>Habilidad: </strong>Fuerza aumentada mediante
                                la droga Venom
                            </p>
                            <hr className="w-25"></hr>
                            <p>
                                Bane es uno de los enemigos más formidables de Batman. Criado
                                en una prisión brutal desde su infancia, desarrolló una mente
                                estratégica excepcional y una enorme resistencia física. Su vida
                                estuvo marcada por la supervivencia y el deseo de demostrar su
                                superioridad sobre cualquier oponente.
                            </p>
                            <p>
                                Gracias a una sustancia llamada Venom, Bane puede aumentar
                                temporalmente su fuerza a niveles sobrehumanos. Sin embargo,
                                su mayor peligro no es solo su fuerza, sino su inteligencia
                                estratégica, que le permite enfrentarse y planear ataques
                                contra Batman.
                            </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                            <img src="/imagenes/bane.jpg" className="img-fluid" alt="bane"></img>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <h1 className="titulo text-center">
                                POISON IVY
                            </h1>
                            <hr></hr>
                            <p>
                                <strong>Nombre real: </strong>Pamela Isley<br></br>
                                <strong>Habilidad: </strong>Control sobre plantas, toxinas y 
                                feromonas
                            </p>
                            <hr className="w-25"></hr>
                            <p>
                                Poison Ivy es una villana obsesionada con proteger la 
                                naturaleza a cualquier costo. Utiliza plantas 
                                mutantes, toxinas y feromonas para manipular y atacar 
                                a sus enemigos, dejando siempre claro que su prioridad 
                                es defender el medio ambiente. Su estilo y métodos la 
                                convierten en una adversaria astuta y peligrosa para 
                                Batman.
                            </p>
                            <p>
                                Pamela busca reconocimiento y validación por 
                                su causa, y aunque sus métodos son criminales, su 
                                inteligencia, carisma y capacidad de manipulación 
                                la hacen compleja.
                            </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                            <img src="/imagenes/poison-ivy.jpg" className="img-fluid" alt="poison-ivy"></img>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <h1 className="titulo text-center">TWO-FACE</h1>
                            <hr></hr>
                            <p>
                                <strong>Nombre real:</strong> Harvey Dent<br></br>
                                <strong>Especialidad: </strong>Estrategia criminal y 
                                uso de armas<br></br>
                                <strong>Rasgo característico: </strong>
                                Decide el destino de sus víctimas con una moneda
                            </p>
                            <hr className="w-25"></hr>
                            <p>
                                Harvey Dent fue alguna vez uno de los fiscales más 
                                respetados de Ciudad Gótica y un aliado cercano de 
                                Batman en la lucha contra el crimen. Sin embargo, un 
                                ataque con ácido destruyó la mitad de su rostro y 
                                también su cordura.
                            </p>
                            <p>
                                Consumido por su dualidad, Two-Face toma todas sus 
                                decisiones lanzando una moneda marcada: un lado 
                                representa la justicia, el otro el caos. Para él, el 
                                destino decide quién vive y quién muere, convirtiéndolo 
                                en uno de los enemigos más trágicos y peligrosos que 
                                Batman ha enfrentado.
                            </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                            <img src="/imagenes/two-face.jpg" className="img-fluid" alt="two-face"></img>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <h1 className="titulo text-center">THE RIDDLER</h1>
                            <hr></hr>
                            <p>
                                <strong>Nombre real: </strong>Edward Nigma<br></br>
                                <strong>Habilidad: </strong>Experto en lógica y gran 
                                conocimiento tenológico
                            </p>
                            <hr className="w-25"></hr>
                            <p>
                                The Riddler es un villano obsesionado con los acertijos, 
                                enigmas y rompecabezas. Su marca personal es dejar pistas 
                                crípticas en sus crímenes para desafiar a Batman y 
                                demostrar su superioridad intelectual.
                            </p>
                            <p>
                                Edward Nigma busca reconocimiento y validación de su 
                                inteligencia. Para él, cometer un crímen es menos 
                                importante que el hecho de que Batman pueda resolver sus 
                                enigmas. Su orgullo y obsesión por demostrar que es 
                                más inteligente que los demás lo convierten en un villano 
                                peligroso, aunque a veces su ego lo traiciona.
                            </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                            <img src="/imagenes/riddler.jpg" alt="riddler"  className="img-fluid"></img>
                        </div>
                    </div>
                </div>

                <Paginacion></Paginacion>
                
            </div>
        </div>
    )
}